import router from '@/router/router'
import store from '@/store/store'
import swal from 'sweetalert2'
import { tratarErroDoBackParaString, informarErroServidor } from '../../utils'
import * as Sentry from '@sentry/vue'
import i18n from '../../locales/i18n'
import { formatarObjetoWebParaSentry } from '../../sentry.ts'

export const tratarErroColetor = (erro) => {
  if (erro.status >= 500) {
    const mensagemErro = informarErroServidor.montarMensagemDeErroServidor()
    const codigoErro = informarErroServidor.montarCodigoErroServidor('GC', 'NC', erro.status)
    store.commit('resetData')

    Sentry.captureEvent({
      message: 'Tratar erro 500 do coletor (clear)',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })

    swal({
      type: 'error',
      text: mensagemErro,
      footer: codigoErro,
      allowEnterKey: true,
      showConfirmButton: true
    }).then(result => {
      Sentry.captureException('Tratar erro 500 do coletor(clear)', erro)

      router.push({ name: 'clear' })
    })
    return
  }

  if (erro.status === 400 && erro.body?.detail === 'reCAPTCHA requerido para o coletor') {
    store.commit('modalRecaptcha', true)
    return
  }

  let mensagemErro = erro.message || tratarErroDoBackParaString(erro.body?.detail) || informarErroServidor.montarMensagemDeErroServidor()

  if (erro.status === 400 && erro.body?.detail === 'Empregado não encontrado ou não preparado para o rep-p') {
    mensagemErro = i18n.t('componentes.coletor.utils.erroColetorEmpregadoNaoEncontrado')
  }

  if (erro.status === 400 && erro.body?.detail === 'O usuário não está vinculado a um empregado') {
    mensagemErro = i18n.t('componentes.coletor.utils.erroColetorUsuarioNaoVinculadoEmpregado')
  }

  store.commit('resetData')

  swal({
    type: 'error',
    text: mensagemErro
  }).then(result => {
    Sentry.captureException(erro)
    router.push({ name: 'clear' })
  })
}

export const tratarErroLoginColetor = (erro, ehSSO = false) => {
  const mensagemErro = informarErroServidor.montarMensagemDeErroServidor()
  const codigoErro = informarErroServidor.montarCodigoErroServidor('GC', 'LC', erro.status)
  if (erro.status >= 500) {
    Sentry.captureEvent({
      message: 'Tratar erro login coletor',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })

    swal({
      type: 'error',
      text: mensagemErro,
      footer: codigoErro,
      allowEnterKey: true,
      showConfirmButton: true,
      confirmButtonText: i18n.t('componentes.coletor.utils.erroLoginColetor.erro500.botaoTentarNovamente')
    }).then(result => {
      if (result) {
        if (ehSSO) {
          store.dispatch('coletor/logarColetorSSO')
          return
        }
        store.dispatch('coletor/logarColetor')
      }
    })
    return
  }
  if (erro.status === 400 && erro.body?.detail === 'reCAPTCHA requerido para o coletor') {
    store.commit('modalRecaptcha', true)
    return
  }
  if (
    (erro.status === 400 && erro.body?.detail === 'Coletor inválido') ||
    (erro.status === 400 && erro.body?.detail === 'Chave do dispositivo inválida') ||
    (erro.status === 400 && erro.body?.detail === 'Coletor não aprovado')
  ) {
    Sentry.withScope(function (scope) {
      scope.setLevel('info')
      Sentry.captureException(erro)
    })
    let mensagemErro = tratarErroDoBackParaString(erro.body.detail)

    if (
      erro.body.detail === 'Coletor inválido' ||
      erro.body.detail === 'Coletor não aprovado'
    ) {
      mensagemErro = i18n.t('componentes.coletor.utils.erroLoginColetor.erro400ColetorInvalido')
    }

    swal({
      type: 'error',
      text: mensagemErro
    }).then(result => {
      Sentry.captureEvent({
        message: 'Coletor inválido || Chave do dispositivo inválida || Coletor não aprovado',
        contexts: {
          localStorage: {
            web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
          }
        }
      })
      router.push({name: 'clear'})
    })
    return
  }
  if (erro.status === 0) {
    const tentativasLogin = store.state.coletor.tentativasLogin
    if (tentativasLogin === 3) {
      Sentry.captureEvent({
        message: 'Login Coletor falhou 3 vezes - timeout'
      })
      store.commit('coletor/atribuiTentativasLogin', 0)
      swal({
        type: 'error',
        text: mensagemErro || i18n.t('componentes.coletor.utils.erroLoginColetor.erro0.texto'),
        footer: codigoErro,
        allowEnterKey: true,
        showConfirmButton: true,
        confirmButtonText: i18n.t('componentes.coletor.utils.erroLoginColetor.erro0.botaoTentarNovamente')
      }).then(result => {
        if (result) {
          if (ehSSO) {
            store.dispatch('coletor/logarColetorSSO')
            return
          }
          store.dispatch('coletor/logarColetor')
        }
      })
      return
    }

    store.commit('coletor/atribuiTentativasLogin', tentativasLogin + 1)
    setTimeout(() => {
      if (ehSSO) {
        store.dispatch('coletor/logarColetorSSO')
        return
      }
      store.dispatch('coletor/logarColetor')
    }, 2000)
    return
  }

  Sentry.captureException(erro.body?.detail || erro)
  swal({
    type: 'error',
    text: tratarErroDoBackParaString(erro.body?.detail) || i18n.t('componentes.coletor.utils.erroColetor')
  })
}

export const validarStatusColetor = () => {
  if (router.currentRoute.name === 'coletorPendente') {
    store.commit('coletorPendente', true, {root: true})
    store.commit('coletor/resetState', {}, {root: true})
    return
  }
  store.commit('coletorPendente', true, {root: true})
  store.commit('coletor/resetState', {}, {root: true})
  router.push({ name: 'coletorPendente' })
}

export const validarCamposCriarColetor = () => {
  const regexCaracteresEspeciais = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ0-9\-_()~ ]{3,}$/
  const nome = store.state.coletor.criarColetor.nome
  const menosQue3Caracteres = nome ? nome.length < 3 : true
  const ehParaEquipe = Boolean(store.state.coletor.criarColetor.modo === 'equipe')
  const ehIndividual = Boolean(store.state.coletor.criarColetor.modo === 'individual')
  const ehFuncionario = store.state.coletor.criarColetor.ehFuncionario
  const temLocalSelecionado = Boolean(store.state.coletor.criarColetor.locais.selecionado.length)
  const modoTodosLocais = store.state.coletor.criarColetor.modo === 'todos'
  const temPerfilSelecionado = Boolean(store.state.coletor.perfisDeColetor.selecionado)
  const temEmpregadoSelecionado = Boolean(Object.keys(store.state.coletor.criarColetor.empregados.selecionado).length)

  if (!regexCaracteresEspeciais.test(nome) || menosQue3Caracteres) {
    swal({
      type: 'error',
      title: i18n.t('componentes.coletor.utils.erroValidarCamposCriarColetor.nomeDoEmpregado.titulo'),
      text: i18n.t('componentes.coletor.utils.erroValidarCamposCriarColetor.nomeDoEmpregado.texto')
    })
    return true
  }
  if (!ehFuncionario) {
    if ((ehParaEquipe || ehIndividual) && !temPerfilSelecionado) {
      swal({
        type: 'error',
        text: i18n.t('componentes.coletor.utils.erroValidarCamposCriarColetor.naoEhFuncionario.configuracao')
      })
      return true
    }
    if (ehParaEquipe && !temLocalSelecionado && !modoTodosLocais) {
      swal({
        type: 'info',
        text: i18n.t('componentes.coletor.utils.erroValidarCamposCriarColetor.naoEhFuncionario.local')
      })
      return true
    }
    if (ehIndividual && !temEmpregadoSelecionado) {
      swal({
        type: 'info',
        text: i18n.t('componentes.coletor.utils.erroValidarCamposCriarColetor.naoEhFuncionario.funcionario')
      })
      return true
    }
  }
}

export const validarCamposRestaurarColetor = () => {
  const regexCaracteresEspeciais = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ0-9\-_()~ ]{3,}$/
  const nome = store.state.coletor.restaurarColetor.nome
  const menosQue3Caracteres = nome ? nome.length < 3 : true
  const ehColetivo = store.state.coletor.restaurarColetor.modo === 'COLETIVO'
  const temLocalSelecionado = Boolean(store.state.coletor.restaurarColetor.locais ? store.state.coletor.restaurarColetor.locais.length : false)
  const temFlagTodosLocais = store.state.coletor.restaurarColetor.todos_os_locais

  if (!regexCaracteresEspeciais.test(nome) || menosQue3Caracteres) {
    swal({
      type: 'error',
      title: i18n.t('componentes.coletor.utils.erroValidarCamposRestaurarColetor.nomeInvalido.titulo'),
      text: i18n.t('componentes.coletor.utils.erroValidarCamposRestaurarColetor.nomeInvalido.texto')
    })
    return true
  }
  if (ehColetivo && !temLocalSelecionado && !temFlagTodosLocais) {
    swal({
      type: 'info',
      text: i18n.t('componentes.coletor.utils.erroValidarCamposRestaurarColetor.localDeTrabalho.texto')
    })
    return true
  }
}

export const logarColetorComTokenRecaptcha = async (token) => {
  const parametros = {
    coletor_id: store.state.accessData.coletor.coletorId,
    chave_do_dispositivo: store.state.accessData.coletor.chaveDispositivo,
    cliente_id: store.state.accessData.coletor.clientId,
    recaptcha_response_token: token
  }

  const ehColetorSSO = store.getters['ehColetorSSO']

  if (ehColetorSSO) {
    await store.dispatch('coletor/logarColetorSSO', parametros)
    store.commit('modalRecaptcha', false)
    return
  }

  await store.dispatch('coletor/logarColetor', parametros)
  store.commit('modalRecaptcha', false)
  store.dispatch('sincronizador/fazerSincronizacaoWeb')
}
